import React from 'react'
import classes from './Wrapper.module.css'
import { Paper, Typography } from '@mui/material'
import { LoginImg } from '../../assets/images'
import { chalkwidettx, newlogo } from '../../assets/icons'

const Wrapper = ({ children, welcomeText, description }) => {
  return (
    <div className={classes.wrapperContainer}>
      <Paper elevation={2} className={classes.LoginPaper}>
        <img src={LoginImg} alt="" className={classes.LoginImage} />
        <div className={classes.LoginBox}>
          <div className={classes.LogoHead}>
            <img src={newlogo} alt="" />
            <img src={chalkwidettx} alt="" />
          </div>
          <Typography mt={3} className={classes.WelcomeText}>
            {welcomeText}
          </Typography>
          <Typography mt={1} mb={4} className={classes.LoginDesc}>
            {description}
          </Typography>
          {children}
        </div>
      </Paper>
    </div>
  )
}

export default Wrapper
